import LegalPageLayout from "@/components/LegalPageLayout";

const H = ({ children }) => (
  <h2 className="mt-8 font-serif text-2xl text-navy">{children}</h2>
);

export default function PrivacyPolicy() {
  return (
    <LegalPageLayout
      eyebrow="Legal"
      title="Privacy Policy"
      lastUpdated="February 2026"
      testId="privacy-policy-page"
    >
      <p>
        This Privacy Policy explains how WillSeva ("we", "us", "our") collects, uses,
        stores and protects information you share with us when you use our platform
        and services.
      </p>

      <H>Information We Collect</H>
      <p>
        We collect information you provide when you complete the will-drafting wizard
        and when you request a callback or contact us, including:
      </p>
      <ul className="ml-5 list-disc space-y-1">
        <li>Personal details (name, date of birth, address, religion, marital status)</li>
        <li>Family member, beneficiary, executor and guardian information</li>
        <li>Asset descriptions and approximate values</li>
        <li>Contact details (mobile number, email)</li>
        <li>Payment confirmation data received from our payment processor</li>
      </ul>

      <H>How Your Data Is Stored</H>
      <p>
        Your information is stored on secure cloud infrastructure and treated as
        confidential. We use industry-standard encryption in transit (HTTPS) and
        restrict access to authorised personnel only. Generated will documents are
        retained against your unique reference identifier and may be regenerated on
        request.
      </p>

      <H>Payments</H>
      <p>
        Payments are processed securely through{" "}
        <span className="font-medium">Razorpay</span>. We do not store your card
        number, CVV, UPI PIN or net-banking credentials at any time. Razorpay handles
        all card and bank data under PCI-DSS standards.
      </p>

      <H>Cookies & Basic Analytics</H>
      <p>
        We may use cookies and basic analytics tools to understand site usage and
        improve the experience. No personally identifying data is sold or shared
        with advertisers.
      </p>

      <H>Communications</H>
      <p>
        By submitting a callback request or completing payment, you consent to us
        contacting you by phone, WhatsApp or email regarding your enquiry, your
        will document, or essential service updates.
      </p>

      <H>Data Retention</H>
      <p>
        WillSeva may retain records — including form inputs, generated documents,
        payment records and communication logs — for operational, compliance,
        accounting and legal purposes. Records may be retained for as long as is
        reasonably necessary to support these purposes or as required by applicable
        Indian law.
      </p>

      <H>Your Rights</H>
      <p>
        You may write to us to request access, correction or deletion of personal
        information we hold about you, subject to any legal or operational
        obligations that require us to retain it.
      </p>

      <H>Contact</H>
      <p>
        For privacy-related questions write to us via the{" "}
        <a className="font-medium text-navy underline" href="/contact">Contact Us</a>{" "}
        page or message us on WhatsApp at +91 9167249612.
      </p>
    </LegalPageLayout>
  );
}
